import { ReactElement } from 'react';
import { Link } from '@mui/material';
import { getSchema } from '@localstack/services';
import { VPC } from '@localstack/types';

import { MagicTable } from '../../magic/MagicTable';

export type VPCsTableProps = {
  selectable?: boolean;
  loading?: boolean;
  vpcs: VPC[];
  onViewVpc?: (vpc: VPC) => unknown;
  onSelect?: (ids: string[]) => void;
};

export const VPCsTable = ({ vpcs, selectable = true, loading, onViewVpc, onSelect }: VPCsTableProps): ReactElement => (
  <MagicTable
    schema={getSchema('EC2')}
    entry="Vpc"
    idAttribute="VpcId"
    rows={vpcs}
    selectable={selectable}
    onSelect={onSelect}
    order={['VpcId', 'CidrBlock', 'State', 'IsDefault', 'InstanceTenancy', 'OwnerId']}
    filterColumns={['VpcId', 'CidrBlock', 'State', 'IsDefault', 'InstanceTenancy', 'OwnerId']}
    hideEmptyColumns
    loading={loading}
    externalFields={{
      VpcId: (row) => (
        <Link onClick={() => onViewVpc && onViewVpc(row)} underline="hover">
          {row.VpcId}
        </Link>
      ),
    }}
  />
);
